module.exports = __webpack_public_path__ + "img/x1_2023_01_19@2x.8832f836.png";